/**
 * ResetPasswordModal - Модальное окно для сброса пароля пользователя
 */
import React, { useState } from 'react';
import {
  Modal,
  PasswordInput,
  Checkbox,
  Button,
  Group,
  Stack,
  Alert,
  Text,
} from '@mantine/core';
import { IconAlertCircle, IconKey } from '@tabler/icons-react';

const ResetPasswordModal = ({
  opened,
  onClose,
  onSubmit,
  user,
  loading = false,
}) => {
  const [newPassword, setNewPassword] = useState('');
  const [requireChange, setRequireChange] = useState(true);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!newPassword) {
      setError('Пароль обязателен');
      return;
    }
    if (newPassword.length < 8) {
      setError('Пароль должен быть минимум 8 символов');
      return;
    }

    try {
      await onSubmit(newPassword, requireChange);
      setNewPassword('');
      setRequireChange(true);
      onClose();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleClose = () => {
    setNewPassword('');
    setRequireChange(true);
    setError(null);
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={
        <Group gap="xs">
          <IconKey size={20} />
          <span>Сброс пароля</span>
        </Group>
      }
      size="sm"
    >
      <form onSubmit={handleSubmit}>
        <Stack gap="md">
          <Text size="sm" c="dimmed">
            Сброс пароля для пользователя: <strong>{user?.email}</strong>
          </Text>

          {error && (
            <Alert icon={<IconAlertCircle size={16} />} color="red" variant="light">
              {error}
            </Alert>
          )}

          <PasswordInput
            label="Новый пароль"
            placeholder="Минимум 8 символов"
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />

          <Checkbox
            label="Требовать смену пароля при следующем входе"
            checked={requireChange}
            onChange={(e) => setRequireChange(e.target.checked)}
          />

          <Group justify="flex-end" mt="md">
            <Button variant="subtle" onClick={handleClose}>
              Отмена
            </Button>
            <Button type="submit" loading={loading} color="orange">
              Сбросить пароль
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};

export default ResetPasswordModal;
